import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TrimmedValueDirective } from 'libs/core/src/lib/directives/trim-value.directive';
import { AddressFormGroup, US_STATES } from './address-form.util';

@Component({
  selector: 'lib-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    TrimmedValueDirective,
  ],
})
export class AddressFormComponent {
  readonly form = input.required<AddressFormGroup>();
  /** Prefix for element ids, so shipping and billing forms on one page do not clash. */
  readonly idPrefix = input.required<string>();

  readonly states = US_STATES;

  protected isInvalid(control: keyof AddressFormGroup['controls']): boolean {
    const field = this.form().controls[control];
    return field.invalid && field.touched;
  }
}
